export function requestTranslate() {
  return {
    type: '@lang/REQUEST_TRANSLATE',
  };
}

export function successTranslate(lang) {
  return {
    type: '@lang/SUCCESS_TRANSLATE',
    payload: { lang },
  };
}

export function failedTranslate() {
  return {
    type: '@lang/FAILED_TRANSLATE',
  };
}
